import * as yup from 'yup';
import { FIELD_LIMITS } from 'utils/character-count-utils';

const sessionDetailsModalFormValidation = yup.object().shape({
  highlightMediaUrl: yup.string().trim(),
  sessionOutcomes: yup.array().of(yup.string().trim().required('Please add session outcome in the above field or remove the empty field to continue').max(FIELD_LIMITS.SESSION_OUTCOME.maxLength, `Session outcome must be at most ${FIELD_LIMITS.SESSION_OUTCOME.maxLength} characters`)).optional().label('Session outcomes'),
  // relatedSkills: yup.array().required().min(1).label('Related skills'),
});

export const sessionOutcomeFieldConfigs = {
  outcome: FIELD_LIMITS.SESSION_OUTCOME,
};

export default sessionDetailsModalFormValidation;
